"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
require("../assets/images/map-pin.png");
require("../../node_modules/bootstrap-sass/assets/stylesheets/_bootstrap.scss");
require("../../node_modules/leaflet/dist/leaflet.css");
require("../assets/css/style.scss");
var angular_1 = __importDefault(require("angular"));
require("angular-cookies");
require("vue");
require("ngVue");
require("ngVue/build/plugins");
var drivecoach_run_1 = __importDefault(require("./drivecoach.run"));
var drivecoach_config_1 = __importDefault(require("./drivecoach.config"));
var drivecoach_maincontroller_1 = __importDefault(require("./drivecoach.maincontroller"));
var angular_animate_1 = __importDefault(require("angular-animate"));
var angular_storage_1 = __importDefault(require("angular-storage"));
var angular_sanitize_1 = __importDefault(require("angular-sanitize"));
var angular_ui_mask_1 = __importDefault(require("angular-ui-mask"));
var angular_ui_bootstrap_1 = __importDefault(require("angular-ui-bootstrap"));
require("angular-simple-logger");
require("ui-select");
require("leaflet");
require("ui-leaflet");
var angular_ui_router_1 = __importDefault(require("angular-ui-router"));
var signup_module_1 = __importDefault(require("./signup/signup.module"));
var login_module_1 = require("./login/login.module");
var logout_module_1 = __importDefault(require("./logout/logout.module"));
var services_module_1 = require("./common/services.module");
var directives_module_1 = __importDefault(require("./common/directives.module"));
var reset_password_module_1 = __importDefault(require("./reset-password/reset-password.module"));
var forgot_password_module_1 = __importDefault(require("./forgot-password/forgot-password.module"));
var constants_1 = require("./common/constants");
var models_1 = require("./common/models");
var admin_module_1 = __importDefault(require("./admin/admin.module"));
var student_module_1 = __importDefault(require("./student/student.module"));
var instructor_module_1 = __importDefault(require("./instructor/instructor.module"));
var dependencies = [
    "ngVue",
    "ngVue.plugins",
    angular_ui_router_1.default,
    "nemLogging",
    "ui-leaflet",
    "ui.select",
    "ngCookies",
    angular_ui_bootstrap_1.default,
    angular_ui_mask_1.default,
    angular_sanitize_1.default,
    angular_storage_1.default,
    angular_animate_1.default,
    constants_1.Constants.name,
    models_1.Models.name,
    services_module_1.Services.name,
    directives_module_1.default.name,
    forgot_password_module_1.default.name,
    reset_password_module_1.default.name,
    login_module_1.Login.name,
    logout_module_1.default.name,
    signup_module_1.default.name,
    student_module_1.default.name,
    admin_module_1.default.name,
    instructor_module_1.default.name,
];
angular_1.default
    .module("DriveCoach", dependencies)
    .controller("MainController", drivecoach_maincontroller_1.default)
    .run(drivecoach_run_1.default)
    .config(drivecoach_config_1.default);
